import type { VariantOption } from "../../../types/earmold.types";

export const getVariantMismatchInfo = (
	currentValue: VariantOption | null | undefined,
	oppositeValue: VariantOption | null | undefined,
) => {
	if (!currentValue || !oppositeValue) {
		return {
			isDifferentBetweenSides: false,
		};
	}

	return {
		isDifferentBetweenSides: currentValue.uuid !== oppositeValue.uuid,
	};
};
